import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-left">
        <p>Designed and built by Aboud Jalal</p>
        <p>All rights reserved ©</p>
      </div>
      <div className="footer-right">
        <a href="mailto:aboudjalal1@gmail.com" className="contact-button">Contact Aboud</a>
      </div>
    </footer>
  );
}

export default Footer;
